import {FormEvent, useEffect, useState} from "react";
import {API_URL} from "../constants/constants";
import {authFetch} from "../services/api";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {IDtoOrdAdditional, IParsedAdditional, OnNumberChange, ICreativeContext} from "../types/types";
import {NumericFormat} from "react-number-format";

interface AdditionalFormProps {
    googleDocData: IParsedAdditional;
    onSuccess: (context: ICreativeContext) => void;
}

export const AdditionalForm = ({googleDocData, onSuccess}: AdditionalFormProps) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [formData, setFormData] = useState<IDtoOrdAdditional>({
        googleDocId: '',
        serial: '',
        type: '',
        parent_contract_external_id: '',
        parent_contract_serial_number: '',
        client_external_id: '',
        comment: '',
        client_external_name: '',
        contractor_external_id: 'my',
        subject_type: 'other',
        date: '',
        amount: 0,
        flags: ['vat_included'] as string[],
    });

    useEffect(() => {
        const {
            type,
            additional_date,
            additional_number,
            additional_nds_price,
            client,
            googleDocId,
            service_number,
            parent_contract_external_id,
            client_external_id,
        } = googleDocData;

        setFormData(prev => ({
            ...prev,
            type,
            date: additional_date,
            amount: additional_nds_price,
            serial: `Приложение № ${additional_number}`,
            parent_contract_serial_number: `Договор № ${service_number}`,
            parent_contract_external_id,
            client_external_name: client,
            client_external_id,
            googleDocId,
        }));
    }, [googleDocData]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleNumber = ({floatValue}: OnNumberChange) => {
        setFormData((p) => ({...p, amount: floatValue ?? 0}));
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setLoading(true);

        let nextContext: ICreativeContext | null = null;

        try {
            const response = await authFetch(`${API_URL}/ord/contracts`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (!response.ok) throw new Error(data.message);
            else setError('');

            toast.success('Данные успешно сохранены!');
            nextContext = {
                brand: googleDocData.client,
                contract_external_id: formData.googleDocId,
                contract_external_name: formData.serial,
            };
        } catch (e) {
            console.error('Ошибка при отправке формы:', e);
            setError(`${e}`);
        } finally {
            setLoading(false);
        }

        if (nextContext) onSuccess(nextContext);
    }

    return (
        <div className="container">
            <div className="form-wrapper">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">

                        <label htmlFor="serial" className="form-label">Серийный номер приложения *</label>
                        <input
                            type='text'
                            id="serial"
                            name="serial"
                            className="form-input"
                            value={formData.serial}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="date" className="form-label">Дата заключения *</label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            className="form-input"
                            value={formData.date}
                            onChange={handleChange}
                            required
                        />

<label htmlFor="parent_contract_serial_number" className="form-label">Основной договор</label>
                        <input
                            id="parent_contract_serial_number"
                            name="parent_contract_serial_number"
                            className="form-input"
                            value={formData.parent_contract_serial_number}
                            disabled
                        />

                        <label htmlFor="client_external_name" className="form-label">Клиент</label>
                        <input
                            id="client_external_name"
                            name="client_external_name"
                            className="form-input"
                            value={formData.client_external_name}
                            disabled
                        />

                        <label htmlFor="amount" className="form-label">Сумма, ₽ (включая все налоги)*</label>
                        <NumericFormat
                            id="amount"
                            name="amount"
                            className="form-input"
                            placeholder="Введите сумму"
                            value={formData.amount}
                            thousandSeparator=" "
                            decimalScale={2}
                            fixedDecimalScale
                            onValueChange={handleNumber}
                        />

                        <label htmlFor="comment" className="form-label">Комментарий к договору</label>
                        <input
                            id="comment"
                            name="comment"
                            className="form-input"
                            placeholder="Краткое описание договора"
                            value={formData.comment}
                            onChange={handleChange}
                        />
                        <div className="error-message">{error}</div>
                    </div>
                    <button
                        type="submit"
                        className={`button ${loading ? 'loading' : ''}`}
                        disabled={loading}
                    >
                        {!loading && 'Отправить'}
                    </button>
                </form>
            </div>
        </div>
    );
}
